<template>
    <div class="wrapper">
        <!--投诉新闻排行榜-->
        <div class="complain">
            <div class="head">
                <img style="width:380px;height:45px;" src="../assets/image/椭圆.png" alt="">
                <span class="rankTitle" v-text="title"></span>
                <router-link class="more" :to="{path:'/ComplainView',query:{id:type,title:title}}" v-if="more">
                    <span>MORE></span></router-link>
            </div>
            <div class="rank-list">
                <ul>
                    <!--<router-link class="title"-->
                    <!--:key="index" v-for="(item, index) in list"-->
                    <!--:to="{ path: 'complainInfo',query:{id:item.id,cate:title}}" tag="li"-->
                    <!--v-text="item.title"-->
                    <!--@click="activeUpdate">-->
                    <!--</router-link>-->
                    <swiper :options="swiperOption" ref="mySwiper" @mouseenter="stopAnimate()">
                        <swiper-slide v-for="(item, index) in list" :key="index">
                            <router-link class="title"
                                         :to="{ path: 'complainInfo',query:{id:item.id,cate:title}}" tag="li"
                                         v-text="item.title"
                                         @click="activeUpdate">
                            </router-link>
                        </swiper-slide>

                    </swiper>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "ranking",
    components: {
      swiper,
      swiperSlide,
    },
    props: {
      list: {
        type: [Array, String, Object],
        default: () => []
      },
      more: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '',
      },
      type: {
        type: Number,
        default: 0,
      }
    },
    data() {
      return {
        swiperOption: {
          direction: "vertical",
          loopFillGroupWithBlank: true,
          slidesPerView: 8,
          speed: 2000,
          loop: true,
          autoplay: {
            delay: 0,
            // stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.change-btn-2',
            prevEl: '.change-btn'
          }
        }
      }
    },

    methods: {
      activeUpdate() {
        this.$router.push({path: '/complainInfo', query: {id: item.id, cate: title}})
      },
      stopAnimate() {
        this.$refs.mySwiper.autoplay
      }
    }
  }
</script>

<style scoped lang="less">
    .wrapper {
        width: 380px;
        height: 334px;
        border: 1px solid #bbb;
    }


    .close {
        position: absolute;
        right: 8px;
        top: 8px;
        background: #23457b;
        color: white;
        border-radius: 12px;
        line-height: 20px;
        text-align: center;
        height: 20px;
        width: 20px;
        font-size: 18px;
        padding: 1px;
        cursor: pointer
    }

    .head {
        display: flex;
        width: 380px;
        height: 48px;
        justify-content: space-between;
        position: relative;

        span {
            width: 85px;
            height: 18px;
            font-size: 20px;
            font-family: JZhongYi;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 48px;
            margin: 0 17px;
            position: absolute;
        }

        .more {
            position: absolute;
            right: 95px;

            span {
                color: #ce1c24;
                font-size: 16px;
            }
        }
    }

    .rank-list {
        margin: 20px;

        .title {
            list-style: disc;
            margin: 0 19px;
            font-size: 16px;
            line-height: 31px;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        .swiper-container {
            height: 248px;
        }
    }

</style>
